import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import { APP_LOGIN_URL } from '../constants.js'
import './footer.css'

export const Footer:FunctionComponent = function Footer () {
    return html`<footer class="site-footer">
        <div class="footer-inner">
            <nav class="footer-nav" aria-label="Footer navigation">
                <ul class="footer-links">
                    <li><a href="/tools">Free Tools</a></li>
                    <li><a href="/#how-it-works">How it works</a></li>
                    <li><a href="/#faq">FAQ</a></li>
                    <li><a href=${APP_LOGIN_URL}>Log in</a></li>
                </ul>
                <ul class="footer-links footer-legal">
                    <li><a href="/privacy">Privacy</a></li>
                    <li><a href="/terms">Terms</a></li>
                    <li>
                        <a href="mailto:mail@hvaclogsystem.com">
                            mail@hvaclogsystem.com
                        </a>
                    </li>
                </ul>
            </nav>
            <p class="footer-copy">
                © 2025 hvaclog. All rights reserved.
            </p>
            <p class="footer-disclaimer">
                The free tools and content on this site are for
                educational purposes only and do not constitute
                legal or compliance advice. Consult a qualified
                professional for guidance on EPA Section 608
                obligations specific to your situation.
            </p>
        </div>
    </footer>`
}
